import { call, put } from 'redux-saga/effects';
import { commonService } from '../services/commonService'
import { commonConstants } from '../actions/constants/commonConstants';
import { localData } from "@/services/helper";



function* getServiceList(): any {
    try {
        const response = yield call(commonService.getServiceList);
        if (response && response.success) {
            yield put({ type: commonConstants.getServicesListSuccess, payload: response.resultObject })
        } else {
            yield put({ type: commonConstants.getServicesListFailure, payload: response })
        }
    } catch (error) {
        yield put({ type: commonConstants.getServicesListFailure, payload: error })
    }
}

function* getSpecializationsList(): any {
    try {
        const response = yield call(commonService.getSpecializationsList);
        if (response && response.success) {
            yield put({ type: commonConstants.getSpecializationsListSuccess, payload: response.resultObject })
        } else {
            yield put({ type: commonConstants.getSpecializationsListFailure, payload: response })
        }
    } catch (error) {
        yield put({ type: commonConstants.getSpecializationsListFailure, payload: error })
    }
}

function* getDocumentTypesList(): any {
    try {
        const response = yield call(commonService.getDocumentTypesList);
        if (response && response.success) {
            yield put({ type: commonConstants.getDocumentTypesListSuccess, payload: response.resultObject })
        } else {
            yield put({ type: commonConstants.getDocumentTypesListFailure, payload: response })
        }
    } catch (error) {
        yield put({ type: commonConstants.getDocumentTypesListFailure, payload: error })
    }
}

function* uploadFile(action: any): any {
    try {
        const response = yield call(commonService.uploadFile, action.payload);
        if (response && response.success) {
            yield put({ type: commonConstants.uploadFileSuccess, payload: response.resultObject })
            // Call onSuccess callback if provided
            if (action.payload.onSuccess) {
                action.payload.onSuccess(response.resultObject);
            }
        } else {
            yield put({ type: commonConstants.uploadFileFailure, payload: response })
            // Call onError callback if provided
            if (action.payload.onError) {
                action.payload.onError(response.message || 'Upload failed');
            }
        }
    } catch (error: any) {
        yield put({ type: commonConstants.uploadFileFailure, payload: error })
        // Call onError callback if provided
        if (action.payload.onError) {
            action.payload.onError(error.message || 'Upload failed');
        }
    }
}

function* removeFile(action: any): any {
    try {
        const response = yield call(commonService.removeFile, action.payload);
        if (response && response.success) {
            yield put({ type: commonConstants.removeFileSuccess, payload: response.resultObject })
            // Call onSuccess callback if provided
            if (action.payload.onSuccess) {
                action.payload.onSuccess(response.resultObject);
            }
        } else {
            yield put({ type: commonConstants.removeFileFailure, payload: response })
            // Call onError callback if provided
            if (action.payload.onError) {
                action.payload.onError(response.message || 'Remove failed');
            }
        }
    } catch (error: any) {
        yield put({ type: commonConstants.removeFileFailure, payload: error })
        // Call onError callback if provided
        if (action.payload.onError) {
            action.payload.onError(error.message || 'Remove failed');
        }
    }
}

function* getRole(action: any): any {
    try {
        const response = yield call(commonService.getRole, action.payload);
        if (response && response.success) {
            yield put({ type: commonConstants.getRoleSuccess, payload: response.resultObject });
            // yield put({type:commonConstants.showSuccessMessage,payload:response.message});

        } else {
            yield put({ type: commonConstants.getRoleFailure, payload: response?.message || response });
            yield put({ type: commonConstants.showErrorMessage, payload: response?.message || 'Unable to fetch roles' });
        }

    } catch (error: any) {
        yield put({ type: commonConstants.getRoleFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error?.message || 'Unable to fetch roles' });
    }

}

function* getStudioList(action: any): any {
    try {
        const response = yield call(commonService.getStudioList, action.payload);
        if (response && response.success) {
            yield put({ type: commonConstants.getStudioListSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.getStudioListFailure, payload: response?.message || response });
            yield put({ type: commonConstants.showErrorMessage, payload: response?.message || 'Unable to fetch studios' });
        }

    } catch (error: any) {
        yield put({ type: commonConstants.getStudioListFailure, payload: error });
        yield put({ type: commonConstants.showErrorMessage, payload: error?.message || 'Unable to fetch studios' });
    }

}

function* getAlbumTemplatesList(): any {
    try {
        const response = yield call(commonService.getAlbumTemplatesList);
        if (response && response.success) {
            yield put({ type: commonConstants.getAlbumTemplatesSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.getAlbumTemplatesFailure, payload: response });
        }
    } catch (error) {
        yield put({ type: commonConstants.getAlbumTemplatesFailure, payload: error });
    }
}

function* getNotificationCount(): any {
    try {
        const response = yield call(commonService.getNotificationCount);
        if (response.success) {
            yield put({ type: commonConstants.getNotificationCountSuccess, payload: response.resultObject.notificationCount });
        }
        else {
            yield put({ type: commonConstants.getNotificationCountFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.getNotificationCountFailure, payload: error });
    }
}

function* listNotifications(action: any): any {
    try {
        const response = yield call(commonService.listNotifications, action?.input?.payload || {});
        if (response.success) {
            yield put({
                type: commonConstants.listNotificationsSuccess,
                payload: { ...response.resultObject, append: action.payload?.append ?? false },
            });
        } else {
            yield put({ type: commonConstants.listNotificationsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.listNotificationsFailure, payload: error });
    }
}

function* markOneRead(action: any): any {
    try {
        const response = yield call(commonService.markOneRead, action.payload.id);
        if (response.success) {
            yield put({ type: commonConstants.markOneReadSuccess, payload: action.payload.id });
            yield put({ type: commonConstants.getNotificationCountRequest });
        } else {
            yield put({ type: commonConstants.markOneReadFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.markOneReadFailure, payload: error });
    }
}

function* markAllRead(): any {
    try {
        const response = yield call(commonService.markAllRead);
        if (response.success) {
            yield put({ type: commonConstants.markAllReadSuccess });
            // refresh count to 0
            yield put({ type: commonConstants.getNotificationCountRequest });
        } else {
            yield put({ type: commonConstants.markAllReadFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.markAllReadFailure, payload: error });
    }
}

function* fetchNotificationSettings(action: any): any {
    try {
        const response = yield call(commonService.fetchNotificationSettings);
        if (response.success) {
            yield put({ type: commonConstants.fetchNotificationSettingsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.fetchNotificationSettingsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.fetchNotificationSettingsFailure, payload: error });
    }
}

function* updateNotificationSettings(action: any): any {
    try {
        const { services } = action.payload;
        const response = yield call(commonService.updateNotificationSettings, services);
        if (response.success) {
            yield put({ type: commonConstants.updateNotificationSettingsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.updateNotificationSettingsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.updateNotificationSettingsFailure, payload: error });
    }
}

function* contactUs(action: any): any {
    try {

        const response = yield call(
            commonService.contactUs,
            action.payload
        );

        if (response && response.success) {

            yield put({
                type: commonConstants.contactUsSuccess,
                payload: response.resultObject,
            });

            yield put({
                type: commonConstants.showSuccessMessage,
                payload: response.message || "Message sent successfully",
            });

            if (action.payload.onSuccess) {
                action.payload.onSuccess(response.resultObject);
            }

        } else {

            yield put({
                type: commonConstants.contactUsFailure,
                payload: response,
            });

            yield put({
                type: commonConstants.showErrorMessage,
                payload: response?.message || "Unable to send message",
            });

            if (action.payload.onError) {
                action.payload.onError(
                    response?.message || "Unable to send message"
                );
            }
        }

    } catch (error: any) {

        yield put({
            type: commonConstants.contactUsFailure,
            payload: error,
        });

        yield put({
            type: commonConstants.showErrorMessage,
            payload: error?.message || "Unable to send message",
        });

        if (action.payload.onError) {
            action.payload.onError(
                error?.message || "Unable to send message"
            );
        }
    }
}

function* getRoutes(): any {
    try {
        const response = yield call(commonService.getRoutes);
        if (response && response.success) {
            yield put({ type: commonConstants.getRoutesListSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.getRoutesListFailure, payload: response?.message || response });
            yield put({ type: commonConstants.showErrorMessage, payload: response?.message || 'Unable to fetch routes ' });
        }

    } catch (error: any) {
        yield put({ type: commonConstants.getStudioListFailure, payload: error });
        yield put({ type: commonConstants.getRoutesListFailure, payload: error?.message || 'Unable to fetch routes' });
    }

}

function* getAccessibleRoutes(): any {
    try {
        const response = yield call(commonService.getAccessibleRoutes);
        if (response && response.success) {
            const localUser: any = localData.get("AUTHDATA");
                const updatedUser = {
                    ...localUser,
                    subscriptionStatus: response.resultObject?.status,
                }
                localData.set("AUTHDATA", updatedUser);
            yield put({ type: commonConstants.getAccessibleRoutesListSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.getAccessibleRoutesListFailure, payload: response?.message || response });
        }

    } catch (error: any) {
        yield put({ type: commonConstants.getAccessibleRoutesListFailure, payload: error });
        yield put({ type: commonConstants.getRoutesListFailure, payload: error?.message || 'Unable to fetch routes' });
    }

}

function* viewNotification(action: any): any {
    try {
        const response = yield call(commonService.viewNotification, action.payload.id);
        console.log('viewNotification response:', response);
        if (response.success) {
            yield put({ type: commonConstants.viewNotificationSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.viewNotificationFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.viewNotificationFailure, payload: error });
    }
}

function* kycNameCheck(action: any): any {
    try {
        const response = yield call(commonService.checkKycName, action.payload);
        if (response.success) {
            yield put({ type: commonConstants.kycNameCheckSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.kycNameCheckFailure, payload: response.resultObject });
            yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.kycNameCheckFailure, payload: error });
    }
}
function* generateSessionSas(action: any): any {
    try {
        const response = yield call(commonService.generateSessionSas);
        if (response.success) {
            yield put({ type: commonConstants.generateSessionSasSuccess, payload: response.resultObject });
        } else {
            yield put({ type: commonConstants.generateSessionSasFailure, payload: response.resultObject });
            yield put({ type: commonConstants.showErrorMessage, payload: response?.errorMessage });
        }
    } catch (error) {
        yield put({ type: commonConstants.generateSessionSasFailure, payload: error });
    }
}

export const commonSaga = {
    getServiceList,
    getSpecializationsList,
    getDocumentTypesList,
    uploadFile,
    contactUs,
    removeFile,
    getRole,
    getStudioList,
    getAlbumTemplatesList,
    getNotificationCount,
    listNotifications,
    markAllRead,
    markOneRead,
    fetchNotificationSettings,
    updateNotificationSettings,
    getRoutes,
    getAccessibleRoutes,
    viewNotification,
    kycNameCheck,
    generateSessionSas
}